import type { FilterId } from '../../common/types/filters';

/**
 * Defines the display ordering for filters.
 * This is a subset of search-page's filterIdOrdering, scoped to FilterIds relevant to 3P connectors.
 */
export const filterIdOrdering: readonly FilterId[] = [
	'lastUpdated',
	'universalTypeFilter',
	'contributor',
	'space',
	'createdBy',
	'lastUpdatedBy',
	'calendarType',
	'leadStatus',
	'taskStatus',
	'taskType',
	'campaignStatus',
	'caseStatus',
	'documentStatus',
	'opportunityStatus',
	'owner',
	'assignee',
	'project',
	'content',
	'label',
	'onlyTitleMatch',
	'pullRequestStatus',
	'salesforceStage',
	'slackChannel',
] as const;
